var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page_bg"},[_c('div',{staticClass:"pagebox"},[_c('div',{staticClass:"page_title"},[_vm._v(_vm._s(_vm.page.title))]),_c('div',{staticClass:"page_date"},[_vm._v(_vm._s(_vm.page.create_at))])])]),_c('div',{attrs:{"id":"page_content"},domProps:{"innerHTML":_vm._s(_vm.page.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }